export const PLAYER_NOTIFICATION_PREFS_KEY = 'notification-preferences';

export interface PlayerNotificationPrefs {
  pairings: boolean;
  results: boolean;
  roundStarting?: boolean;
  pairingReady?: boolean;
  resultsPosted?: boolean;
  tournamentComplete?: boolean;
  roundStartingMinutes?: number;
}

export const DEFAULT_PLAYER_NOTIFICATION_PREFS: PlayerNotificationPrefs = {
  pairings: true,
  results: true,
  roundStarting: true,
  pairingReady: true,
  resultsPosted: true,
  tournamentComplete: true,
  roundStartingMinutes: 5,
};

export function loadPlayerNotificationPrefs(): PlayerNotificationPrefs {
  try {
    const saved = localStorage.getItem(PLAYER_NOTIFICATION_PREFS_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      return { ...DEFAULT_PLAYER_NOTIFICATION_PREFS, ...parsed };
    }
  } catch {
    // fall through
  }
  return { ...DEFAULT_PLAYER_NOTIFICATION_PREFS };
}

export function savePlayerNotificationPrefs(prefs: Partial<PlayerNotificationPrefs>): PlayerNotificationPrefs {
  const merged = { ...loadPlayerNotificationPrefs(), ...prefs };
  localStorage.setItem(PLAYER_NOTIFICATION_PREFS_KEY, JSON.stringify(merged));
  return merged;
}

/** True when the player wants pairing and/or result push notifications. */
export function arePlayerNotificationsEnabled(prefs: PlayerNotificationPrefs = loadPlayerNotificationPrefs()): boolean {
  return Boolean(prefs.pairings || prefs.results);
}
